import { API_KEY, API_URL } from "../data/constant";
import { chartGenerationPrompt, getTextDataFromSummaryPrompt, summarizeTextPrompt, tableGenerationPrompt, textGenerationPrompt } from "./prompt";
//Provide current status of PPT and returns full config of PPT
export const getCurrentStatusOfPPT = (slidesConfig, activeSlide) => {
  const prevConfigs = [...slidesConfig];

  // Update numberOfMedia for each slide based on media types in slideDataArray
  prevConfigs.forEach((slide) => {
    const mediaCount = slide.slideDataArray.filter((item) =>
      ["image", "chart", "table"].includes(item.type)
    ).length;
    slide.numberOfMedia = Math.min(mediaCount, 2); // Cap at 2

    // Check presence of each media type
    slide.isChartPresent = slide.slideDataArray.some(
      (item) => item.type === "chart"
    );
    slide.isTablePresent = slide.slideDataArray.some(
      (item) => item.type === "table"
    );
    slide.isImagePresent = slide.slideDataArray.some(
      (item) => item.type === "image"
    );
    slide.isTextPresent = slide.slideDataArray.some(
      (item) => item.type === "text"
    );

    // Check if chart/table were generated by content
    slide.isChartGeneratedByContent =
      slide.isChartPresent &&
      slide.slideDataArray.some(
        (item) => item.type === "chart" && item.isGeneratedByContent
      );

    slide.isTableGeneratedByContent =
      slide.isTablePresent &&
      slide.slideDataArray.some(
        (item) => item.type === "table" && item.isGeneratedByContent
      );
  });

  const lastSlide = prevConfigs[activeSlide - 1];
  const lastSlideItems = lastSlide?.slideDataArray;

  if (lastSlideItems.length === 3) {
  }

  const isTextAvailable = lastSlideItems.some((item) => item.type === "text");
  lastSlide.isTextAvailable = isTextAvailable;
  return { prevConfigs, lastSlide, lastSlideItems, isTextAvailable };
};

// Provide slide status returns updated slide config
export const getSlideStatus = (slide) => {
  if (!slide) return;
  // Deep clone the input slide object
  const updatedSlide = JSON.parse(JSON.stringify(slide));

  // Get slideDataArray from input
  const slideDataArray = updatedSlide.slideDataArray || [];

  // Calculate number of media items (capped at 2)
  const mediaCount = slideDataArray.filter((item) =>
    ["image", "chart", "table"].includes(item.type)
  ).length;
  updatedSlide.numberOfMedia = Math.min(mediaCount, 2);

  // Check presence of each content type
  updatedSlide.isChartPresent = slideDataArray.some(
    (item) => item.type === "chart"
  );
  updatedSlide.isTablePresent = slideDataArray.some(
    (item) => item.type === "table"
  );
  updatedSlide.isImagePresent = slideDataArray.some(
    (item) => item.type === "image"
  );
  updatedSlide.isTextPresent = slideDataArray.some(
    (item) => item.type === "text"
  );

  // Check if chart/table were AI generated
  updatedSlide.isChartGeneratedByContent =
    updatedSlide.isChartPresent &&
    slideDataArray.some(
      (item) => item.type === "chart" && item.isGeneratedByContent
    );

  updatedSlide.isTableGeneratedByContent =
    updatedSlide.isTablePresent &&
    slideDataArray.some(
      (item) => item.type === "table" && item.isGeneratedByContent
    );

  // Set text availability flag
  updatedSlide.isTextAvailable = updatedSlide.isTextPresent;

  return updatedSlide;
};


// _____________Prompts Starts_________________

// CHART LLM GENERATION
export async function generateChartDataUsingLLM(message, chartType) {
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": API_KEY,
      },
      Accept: "application/json",
      body: chartGenerationPrompt(chartType, message),
    });

    const data = await response.json();
    console.log("LLM Response:", data);
    const responseData = data.choices[0].message.content;
    const chartDataMatch = responseData.match(
      /var chartData = (\[[\s\S]*?\]);/
    );

    if (chartDataMatch) {
      // WARNING: Using eval - consider using JSON.parse with proper validation instead
      const chartData = eval(chartDataMatch[1]);

      return chartData;
    }

    console.log("chartData not found!");
    return null;
  } catch (error) {
    console.error("Error generating chart data:", error);
    throw error;
  }
}

// TABLE LLM GENERATION
export async function generateTableDataUsingLLM(message) {

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": API_KEY,
      },
      Accept: "application/json",
      body: tableGenerationPrompt(message),
    });

    const data = await response.json();
    console.log("LLM Response:", data);
    const responseData = data.choices[0].message.content;
    const match = responseData.match(/```javascript\s*([\s\S]*?)\s*```/);

    if (!match) return null;

    const code = match[1];
    const tableDataMatch = code.match(/tableData\s*=\s*(\[[\s\S]*?\]);/);
    const tableData = tableDataMatch ? eval(tableDataMatch[1]) : null;
    console.log("tableData", tableData);
    return tableData;
  } catch (error) {
    console.log("Error in LLM call:", error);
    return null;
  }
}

// TEXT LLM GENERATION
export async function generateTextDataUsingLLM(paraInput) {
  console.log("paraInput", paraInput);
 
  const defaultParagraph = `There are a number of reasons you may need a block of text and when you do, a random paragraph can be the perfect solution. If you happen to be a web designer and you need some random text to show in your layout, a random paragraph can be an excellent way to do this. If you're a programmer and you need random text to test the program, using these paragraphs can be the perfect way to do this. Anyone who's in search of realistic text for a project can use one or more of these random paragraphs to fill their need.

Improve Writing
For writers looking for a way to get their creative writing juices flowing, using a random paragraph can be a great way to do this. One of the great benefits of this tool is that nobody knows what is going to appear in the paragraph. This can be leveraged in a few different ways to force the writer to use creativity. For example, the random paragraph can be used as the beginning paragraph of a story that the writer must finish. I can also be used as a paragraph somewhere inside a short story, or for a more difficult creative challenge, it can be used as the ending paragraph. In every case, the writer is forced to use creativity to incorporate the random paragraph into the story.`;

  const paragraph = paraInput || defaultParagraph;

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": API_KEY,
      },
      Accept: "application/json",
      body: textGenerationPrompt(paragraph),
    });

    const data = await response.json();
    console.log("LLM Response:", data);
    const responseData = data.choices[0].message.content;

    const jsonMatch = responseData.match(/```json\n([\s\S]*?)\n```/);
    if (!jsonMatch) {
      console.error("No JSON match found in response");
      return null;
    }

    try {
      const bulletData = JSON.parse(jsonMatch[1]);
      console.log("Parsed bullet data:", bulletData);
      return bulletData;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }
  } catch (error) {
    console.log("Error in LLM call:", error);
    return null;
  }
}

//TEXT SUMMARIZATION
export async function summarizeTextUsingLLM(paraInput, TEXT_LIMIT) {
  const API_URL =
    "https://et-genai-azureopenai1-q.openai.azure.com/openai/deployments/gpt-4o_2024-08-06/chat/completions?api-version=2024-02-15-preview";
  const API_KEY = "2dfa39fbfb5746fc92589d6bd63b99a9";

  const defaultParagraph = `There are a number of reasons you may need a block of text and when you do, a random paragraph can be the perfect solution. If you happen to be a web designer and you need some random text to show in your layout, a random paragraph can be an excellent way to do this. If you're a programmer and you need random text to test the program, using these paragraphs can be the perfect way to do this. Anyone who's in search of realistic text for a project can use one or more of these random paragraphs to fill their need.`;

  const paragraph = paraInput || defaultParagraph;

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": API_KEY,
      },
      Accept: "application/json",
      body: summarizeTextPrompt(paragraph, TEXT_LIMIT)
    });

    const data = await response.json();
    console.log("LLM Response:", data);
    const responseData = data.choices[0].message.content;
    console.log("responseData", responseData);
    if (responseData) {
      return responseData;
    }
    return null;
  } catch (error) {
    console.log("Error in LLM call:", error);
    return null;
  }
}
export async function generateTextDataUsingLLMFromSummary(paraInput) {
  console.log("paraInput", paraInput);
  const API_URL =
    "https://et-genai-azureopenai1-q.openai.azure.com/openai/deployments/gpt-4o_2024-08-06/chat/completions?api-version=2024-02-15-preview";
  const API_KEY = "2dfa39fbfb5746fc92589d6bd63b99a9";

  const defaultParagraph = `There are a number of reasons you may need a block of text and when you do, a random paragraph can be the perfect solution. If you happen to be a web designer and you need some random text to show in your layout, a random paragraph can be an excellent way to do this. If you're a programmer and you need random text to test the program, using these paragraphs can be the perfect way to do this. Anyone who's in search of realistic text for a project can use one or more of these random paragraphs to fill their need.

Improve Writing
For writers looking for a way to get their creative writing juices flowing, using a random paragraph can be a great way to do this. One of the great benefits of this tool is that nobody knows what is going to appear in the paragraph. This can be leveraged in a few different ways to force the writer to use creativity. For example, the random paragraph can be used as the beginning paragraph of a story that the writer must finish. I can also be used as a paragraph somewhere inside a short story, or for a more difficult creative challenge, it can be used as the ending paragraph. In every case, the writer is forced to use creativity to incorporate the random paragraph into the story.`;

  const paragraph = paraInput || defaultParagraph;

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": API_KEY,
      },
      Accept: "application/json",
      body: getTextDataFromSummaryPrompt(paragraph)
    });

    const data = await response.json();
    console.log("LLM Response:", data);
    const responseData = data.choices[0].message.content;

    const jsonMatch = responseData.match(/```json\n([\s\S]*?)\n```/);
    if (!jsonMatch) {
      console.error("No JSON match found in response");
      return null;
    }

    try {
      const bulletData = JSON.parse(jsonMatch[1]);
      console.log("Parsed bullet data:", bulletData);
      return bulletData;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }
  } catch (error) {
    console.log("Error in LLM call:", error);
    return null;
  }
}

// _____________Prompts nds_________________

// Calculate fit dimensions
export function calculateFitDimensions(
  originalWidth,
  originalHeight,
  maxWidth = 10,
  maxHeight = 10
) {
  const aspectRatio = originalWidth / originalHeight;
  let newWidth, newHeight;

  if (aspectRatio > 1) {
    newWidth = Math.min(originalWidth, maxWidth);
    newHeight = newWidth / aspectRatio;

    if (newHeight > maxHeight) {
      newHeight = maxHeight;
      newWidth = newHeight * aspectRatio;
    }
  } else {
    newHeight = Math.min(originalHeight, maxHeight);
    newWidth = newHeight * aspectRatio;

    if (newWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = newWidth / aspectRatio;
    }
  }

  return { width: newWidth, height: newHeight };
}

// Get width and height from url
export function getWidthAndHeightFromUrl(url) {
  const urlObj = new URL(url);
  const params = urlObj.searchParams;
  const width = parseInt(params.get("width"), 10);
  const height = parseInt(params.get("height"), 10);
  return { width, height };
}

// Determine table orientation
export function determineTableOrientation(rows = 1, cols = 1) {
  if (rows >= cols * 2) {
    return "portrait";
  } else if (cols >= rows) {
    return "landscape";
  } else {
    return "normal";
  }
}

export function getTextFromObjects(data) {
  if (!data) return;
  for (const item of data) {
    if (item.type === "text") {
      const combinedText =
        item.data.map((obj) => obj?.text?.trim()).join(". ") + ".";
      return combinedText;
    }
  }
  return false;
}
